import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async () => {
  const settingUrl = CONTRACT_MANAGER_URL.SETTING
  const url = `${settingUrl}/terms-of-payment`
  const result = await bService.get(url)

  return result
}

const create = async (data) => {
  const settingUrl = CONTRACT_MANAGER_URL.SETTING
  const url = `${settingUrl}/terms-of-payment`
  const result = await bService.post(url, data)

  return result
}

const update = async (termsOfPaymentId, data) => {
  const settingUrl = CONTRACT_MANAGER_URL.SETTING
  const url = `${settingUrl}/terms-of-payment/${termsOfPaymentId}`
  const result = await bService.put(url, data)

  return result
}

const remove = async (termsOfPaymentId) => {
  const settingUrl = CONTRACT_MANAGER_URL.SETTING
  const url = `${settingUrl}/terms-of-payment/${termsOfPaymentId}`
  const result = await bService.remove(url)

  return result
}

export default {
  list,
  create,
  update,
  remove
}
